import { useCallback } from "react";

import { useAppDispatch } from "~/app/store";
import { useFlag } from "~/config/flags";
import { showPickToLight } from "~/redux/actions/autostore";

type ShowPickToLightParams = Parameters<typeof showPickToLight>;

export const useShowPickToLightFlagged = () => {
  const dispatch = useAppDispatch();
  const { clientSideFusionPortPtl } = useFlag();

  const showPickToLightFlagged = useCallback(
    (...args: ShowPickToLightParams) => {
      if (clientSideFusionPortPtl) {
        return dispatch(showPickToLight(...args));
      }
      // No-op when flag is disabled - allows for gradual deprecation
      return Promise.resolve();
    },
    [dispatch, clientSideFusionPortPtl]
  );

  return { showPickToLightFlagged };
};
